<div class="example-container"  [class.example-is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="example-toolbar" *ngIf="currentUser">
    <button mat-icon-button (click)="snav.toggle()"><mat-icon>menu</mat-icon></button>
    <img class="logo-in-project-box" src="./assets/images/akilli_binalar_logo.png">
    <h1 class="example-app-name">Akıllı Binalar Personel Portalı</h1>

    <div class="user-menu-container">
      <div class="user-menu-content">
        <fa-icon [icon]="faUser" class="user-icon"></fa-icon>
        <button mat-button [matMenuTriggerFor]="menu" class="user-button">Merhaba {{currentUser.userName}}</button>
      </div>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="goProfilePage()">Profilim</button>
        <button mat-menu-item (click)="logout()">Çıkış</button>
      </mat-menu>
    </div>
  </mat-toolbar>

  <mat-sidenav-container class="example-sidenav-container"
                         [style.marginTop.px]="mobileQuery.matches && currentUser ? 56 : 0">
    <mat-sidenav class="sidebar-div" [style.visibility]="sidenavStyle" [opened]="currentUser && opened" #snav [mode]="mobileQuery.matches ? 'over' : 'side'"
                 [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <div *ngIf="currentUser" class="sidebar-menu">
        <mat-accordion multi displayMode="flat">
          <ng-container *ngFor="let group of menuGroups">
            <mat-expansion-panel *ngIf="isGroupVisible(group)"
                                 class="sidebar-panel"
                                 [expanded]="group.expanded"
                                 (opened)="group.expanded = true"
                                 (closed)="group.expanded = false">
              <mat-expansion-panel-header>
                <mat-panel-title class="panel-title">
                  <mat-icon class="menu-group-icon">{{ group.icon }}</mat-icon>
                  <span class="menu-group-text">{{ group.label }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <mat-nav-list class="sub-menu-list">
                <ng-container *ngFor="let item of group.items">
                  <a *ngIf="isItemVisible(item)"
                     mat-list-item
                     class="left-menu-text sub-menu-item"
                     [routerLink]="item.route"
                     routerLinkActive="active-menu-item"
                     (click)="navigateTo(item)">
                    <div class="menu-item-container">
                      <mat-icon class="menu-icon sub-icon">{{ item.icon }}</mat-icon>
                      <span class="menu-text">{{ item.label }}</span>
                    </div>
                  </a>
                </ng-container>
              </mat-nav-list>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </div>
    </mat-sidenav>

    <mat-sidenav-content [style]="sideNavContentStyle" class="main-content">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<app-loader></app-loader>

<div *ngIf="updateAvailable" class="update-banner">
  Yeni bir versiyon mevcut! <button (click)="reloadPage()">Yenile</button>
</div>